import { mapState, mapMutations } from 'vuex';
import { __tokenName } from '../Store/app/utils/vuexutils';

var snack = null;
var appModal = null;

export const AppMixins = {


  data() {
    return {
      $snack: {
        appSnackRef: null,
        top: false,
        bottom: false,
        left: false,
        right: false,
        color: 'error',
        error_text: '',
        timeout: 10000
      }
    }
  },
  components: {
  },
  computed: {

  },
  mutations: {

  },
  methods: {







    //
    // SECURITY
    //
    $hasTokenExpired() {

      // If token does not exist or has expired...it's the same
      var now = new Date().getTime();
      var tokenWithTime = JSON.parse(localStorage.getItem(__tokenName));
      var tokenHasExpired = false;

      if (tokenWithTime != null) {

        var hours = tokenWithTime.Hours;

        if (now - tokenWithTime.time > hours * 60 * 60 * 1000) {
          tokenHasExpired = true;
        }

      } else {
        tokenHasExpired = true; // Nema ništa u local storage
      }

      if (tokenHasExpired == true) {
        localStorage.removeItem(__tokenName);
      }

      return tokenHasExpired;
    },


    //
    // DOWNLOAD BYTE ARRAY: https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
    //
    $downloadByteArray(data, extension, name) {
      var byte = this.base64ToArrayBuffer(data);
      var blob = new Blob([byte], { type: "application/" + extension });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = name;
      link.download = fileName;
      link.click();
    },

    $downloadBlob(blob, extension, name) {

      //var blob = new Blob([byte], { type: "application/" + extension });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = name;
      link.download = fileName;
      link.click();
    },

    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    //
    // AJAX
    //
    $fetchDataPromise(url, data, method, withoutToken) {
      data = data != null ? JSON.stringify(data) : data;
      var self = this;

      return new Promise((resolve, reject) => {
        var request = this.__fetchProps(data, method, withoutToken);

        fetch(url, request)
          //.then(res => this.__convertToJson(res))
          .then(function (res) {

            if (res.ok == false) {
              //reject(result);
              if (res.status == 401) {
                throw self.$t('security._401_msg');
              }
              else if (res.status >= 500) {
                //throw //self.$t('security._500_msg');
                res.json().then(x => { self.$displayErrorModal(x.ExceptionMessage) });
              }
              else {
                // Ako je bilo koja druga greša, prosljeđujem nazad pozivatelju
                //res = res.json().then(x => { throw x }).catch(x => { self.$displayErrorModal(x.Message); });
                res.json().then(x => reject(x.Message));
              }
            } else {
              res = self.__convertToJson(res)
              resolve(res);
            }
          })
          .catch(error => {
            // Ovdje se obrađuju neočekivane greške
            this.$displayErrorModal(error)
          })
          .then(function () {
            //utils.stopLoader();
          });


      });
    },

    __fetchProps(data, method, withoutToken) {
      var token = this.__getToken();

      var props = {};
      method = method == null ? 'POST' : method;
      withoutToken = withoutToken == null ? false : withoutToken;

      if (withoutToken == false) {
        props = {
          method: method, body: data,
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + (token != null ? token : '')
          })
        }
      } else {
        props = {
          method: method, body: data,
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }
      }

      return props;
    },

    $axiosUpload(url, formDataAxios) {
      var self = this;
      var token = this.__getToken();

      if (this.$hasTokenExpired()) {
        this.$displayError(this.$t('security._401_msg'))
      } else {

        return this.axios.post(url,
          formDataAxios,
          {
            headers: {
              'Content-Type': 'application/json',
              //'Content-Type': 'multipart/form-data',
              'Authorization': 'Bearer ' + (token != null ? token : '')
            }
          })
      }
    },

    __fetchPropsUpload(data) {
      var token = this.__getToken();

      var props = {};

      props = {
        method: method,
        body: data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': "Bearer " + token
        }
        //headers: new Headers({
        //  'Authorization': 'Bearer ' + (token != null ? token : ''),
        //  //'Content-Type': 'undefined'
        //}),
      }

      return props;
    },

    __getToken() {
      var token = JSON.parse(localStorage.getItem(__tokenName));
      return token == null ? '' : token.Token;
    },

    __convertToJson(res) {
      if (res.ok == false) {
        return res;
      } else {
        return res.json();
      }
    },

    __getErrorText(text) {
      if (text) {
        if (text.startsWith('server_msg')) {
          return this.$t(text);
        }
        else {
          return text;
        }
      }

    },


    //
    // MODALI I PORUKE
    //
    __getAppModalText() {
      return __modalText;
    },

    $SET_APP_SNACK(snackRef) {
      snack = snackRef;
    },

    $SET_APP_MODAL(modalRef) {
      appModal = modalRef;
    },

    $SET_SNACK_PROPS(data) {
      var self = this;

      this.$data.$snack.top = false;
      this.$data.$snack.bottom = false;
      this.$data.$snack.left = false;
      this.$data.$snack.right = false;

      for (const loc of data) {
        // Ostali parametri
        if (typeof (loc) == 'object') {
          self.$data.$snack.color = loc.color;
          self.$data.$snack.error_text = loc.text;
        } else {
          self.$data.$snack[loc] = true
        }
      }

    },

    $displayErrorModal(text) {
      if (text.startsWith('server_msg')) {
        appModal.setModalText(this.$t(text));
      }
      else {
        appModal.setModalText(text);
      }

      appModal.dialog = true;
    },

    $displayError(text) {
      snack.snackMe('top', 'center', { text: this.__getErrorText(text), color: 'error' }, 10000)

    },

    $displaySuccess(text) {
      snack.snackMe('top', 'right', { text: this.__getErrorText(text), color: 'success' }, 5000)
    },

    $displayWarning(text) {
      snack.snackMe('top', 'right', { text: this.__getErrorText(text), color: 'warning' }, 7000)
    },

    $displayInfo(text) {
      snack.snackMe('top', 'center', { text: this.__getErrorText(text), color: 'info' }, 5000)
    },

    $displayPrimary(text) {
      snack.snackMe('top', 'right', { text: this.__getErrorText(text), color: 'purple' }, 5000)
    },




  }

}








// WEBPACK FOOTER //
// ./VueSrc/Common/helpers/utils.js